import React from 'react';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import { Cell, Row, Stack, FlexRow, FlexCol, Text, Divider } from 'sarsaparilla';
import { generateLineItems } from 'ui-permit/src/utils/utils';

import FeeEstimate from './FeeEstimate';
import issuanceShape from '../../utils/issuanceShape';
import permitShape from '../../utils/permitShape';
import * as types from '../../constants/index';
import DisplayTripItinerary from './DisplayTripItinerary';
import {
  getDayCardinality,
  hasLotteryPreferenceDateDivisionDuration,
  hasLotteryPreferenceDateDivisionGroupSize,
  readRuleValue
} from '../../utils/permitUtils';
import {
  getPermitTypeInyo,
  OVERNIGHT_EXITING_MT_WHITNEY,
  OVERNIGHT_PERMIT
} from '../../utils/inyoUtils';

const propTypes = {
  permit: permitShape,
  issuance: issuanceShape,
  tripItinerary: PropTypes.arrayOf(PropTypes.shape({})),
};

export default class ReservationDetail extends React.Component {
  renderLengthOfStayPreference(preference) {
    const lengthOfStay = preference.length_of_stay ? `${preference.length_of_stay} ${getDayCardinality(preference.length_of_stay)}` : '';

    return <Row><Cell width={12}>{lengthOfStay}</Cell></Row>;
  }

  renderGroupSizePreference(preference) {
    const groupMinSize = preference.group_min_size;
    const groupMaxSize = preference.group_max_size;
    let groupSelection = '';
    // Display group size only if both values have been selected and are valid
    if (groupMinSize && groupMaxSize) {
      groupSelection += `${groupMinSize} - ${groupMaxSize} people`;
    }

    return <Row><Cell width={12}>{groupSelection}</Cell></Row>;
  }

  renderMultipleDivisionPreferenceDetail(date, idx) {
    const divisionId = date.division_id;
    const { permit } = this.props;
    const divisionName = get(permit, `divisions[${divisionId}].name`, '');
    const selectedDate = date.preferred_date;

    if (moment.isMoment(selectedDate) && selectedDate.isValid()) {
      const key = `${selectedDate.format()}-${idx}`;
      return (
        <div key={key} className="selected-date">
          <Row>
            <Cell width={2}>#{idx + 1}.</Cell>
            <Cell width={10}>
              {divisionName}
              <Row><Cell width={12}>{selectedDate.format(types.DATE_FORMAT)}</Cell></Row>
              {hasLotteryPreferenceDateDivisionDuration(permit, undefined) ? this.renderLengthOfStayPreference(date)
                : null}
              {hasLotteryPreferenceDateDivisionGroupSize(permit, undefined) ? this.renderGroupSizePreference(date)
                : null}
            </Cell>
          </Row>
        </div>
      );
    }

    return null;
  }

  renderPermitDateText() {
    const { issuance } = this.props;
    const entryDate = moment.utc(issuance.start_date).format('LL');
    const exitDate = moment.utc(issuance.end_date).format('LL');

    if (readRuleValue('ShowEntryDateOnly', this.props.permit)) {
      return (
        <FlexRow className="mt-2">
          <FlexCol xs={6}>
            <Text>Check in</Text>
            <Text fontWeight="bold">{entryDate}</Text>
          </FlexCol>
        </FlexRow>
      );
    }

    return (
      <FlexRow className="mt-2">
        <FlexCol xs={6}>
          <Text>Check in</Text>
          <Text fontWeight="bold">{entryDate}</Text>
        </FlexCol>
        <FlexCol xs={6}>
          <Text>Check out</Text>
          <Text fontWeight="bold">{exitDate}</Text>
        </FlexCol>
      </FlexRow>
    );
  }

  render() {
    const { issuance, permit, tripItinerary } = this.props;
    const division = get(permit.divisions, `${issuance.division_id}`, {});
    const fees = get(division, 'fees', []);
    const isVisitingMtWhitney = issuance.is_visiting_mt_whitney;
    const groupMembers = issuance.group_info;
    const lineItems = generateLineItems(issuance, division, permit);

    let type = this.props.issuance.permit_type;
    if (type === getPermitTypeInyo(OVERNIGHT_EXITING_MT_WHITNEY)) {
      type = 'Overnight Exiting Mt. Whitney Permit';
    }
    else if (type === getPermitTypeInyo(OVERNIGHT_PERMIT)) {
      type = 'Overnight Permit';
    }
    else {
      type = '';
    }
    const permitType = issuance.permit_type;

    return (
      <Stack space="xs">
        {type ? <p className="h6">{type}</p> : <hr />}
        {this.renderPermitDateText()}
        <Text size="sm">Entrance Location</Text>
        <Text fontWeight="semibold">{get(division, "name")}</Text>
        <Divider />
        <DisplayTripItinerary tripItinerary={tripItinerary} />
        <Divider />
        <FeeEstimate
          groupMembers={groupMembers}
          division={division}
          permitCount={1}
          fees={fees}
          permitType={permitType}
          permitId={permit.id}
          amountPaid={issuance.amount_paid}
          isVisitingMtWhitney={isVisitingMtWhitney}
          lineItems={lineItems} />
      </Stack>
    );
  }
}

ReservationDetail.propTypes = propTypes;
